<template>
  <div class="app">
    <AppHeader :list="list"/>
    <div class="app-body">
      <Sidebar/>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import AppHeader from '../components/Header'
import Sidebar from '../components/Sidebar'
import AppFooter from '../components/Footer'
import Breadcrumb from '../components/Breadcrumb'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppFooter,
    Breadcrumb
  },
  mounted(){
    var system = window.localStorage.getItem('system');
    if (system === null) {
      window.localStorage.removeItem('system');
      this.$router.push('/');
    }
  },
  watch: {
    '$route'(to, from) {
      var system = window.localStorage.getItem('system');
      if (system === null) {
        window.localStorage.removeItem('system');
        this.$router.push('/');
      }
    }
  },
  computed: {
    name () {
      return this.$route.name
    },

    list () {
      return this.$route.matched
    }
  }
}
</script>



// WEBPACK FOOTER //
// Full.vue?c68cbfe6